import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useReducer, useState } from 'react';
import { IAction } from '../../../../models/constants';
/*models*/
import { IOrderDetails, IOrderHub } from '../../../../models/order';
import { IOrderStatuses } from '../../../../models/order-statuses';
import { ISession } from '../../../../models/pro-sites';
import * as CON from '../../../common/constants';

/*CSS*/
import './order-tracker-styles.css';

import { ProcessingCategory } from './processing';
import { ShippingCategory } from './shipping';
import { OutForDeliveryCategory } from './out-for-delivery';
import { EventMessaging } from './event-messaging';
import { OrderCategory } from './ordering';

interface IOrderTrackerProps {
    order: IOrderDetails;
    session: ISession;
    cancelled: boolean;
}

export const OrderTracker = ({
    order,
    session,
    cancelled,
}: IOrderTrackerProps) => {
    function statusReducer(
        state: IOrderStatuses,
        action: IAction
    ): IOrderStatuses {
        switch (action.type) {
            case 'ordering-active':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        isActive: true,
                    },
                };

            case 'ordering-exception-1':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        exception1: true,
                    },
                };
            case 'ordering-exception-2':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        exception2: true,
                    },
                };

            case 'processing-active':
                return {
                    ...state,
                    ordering: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    processing: {
                        ...state.processing,
                        isActive: true,
                    },
                };
            case 'processing-exception-1':
                return {
                    ...state,
                    processing: {
                        ...state.processing,
                        exception1: true,
                    },
                };
            case 'processing-exception-2':
                return {
                    ...state,
                    processing: {
                        ...state.processing,
                        exception2: true,
                    },
                };

            case 'shipping-active':
                return {
                    ...state,
                    ordering: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    processing: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    shipping: {
                        ...state.shipping,
                        isActive: true,
                    },
                };
            case 'shipping-exception-1':
                return {
                    ...state,
                    shipping: {
                        ...state.shipping,
                        exception1: true,
                    },
                };
            case 'shipping-exception-2':
                return {
                    ...state,
                    shipping: {
                        ...state.shipping,
                        exception2: true,
                    },
                };

            case 'outForDelivery-active':
                return {
                    ...state,
                    ordering: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    processing: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    shipping: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    outForDelivery: {
                        ...state.outForDelivery,
                        isActive: true,
                    },
                };
            case 'outForDelivery-exception-1':
                return {
                    ...state,
                    outForDelivery: {
                        ...state.outForDelivery,
                        exception1: true,
                    },
                };
            case 'outForDelivery-exception-2':
                return {
                    ...state,
                    outForDelivery: {
                        ...state.outForDelivery,
                        exception2: true,
                    },
                };
            case 'outForDelivery-complete':
                return {
                    ...state,
                    ordering: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    processing: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    shipping: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                    outForDelivery: {
                        isActive: false,
                        exception1: false,
                        exception2: false,
                        isCompleted: true,
                    },
                };
            case 'ordering-reactivated':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        isActive: true,
                    },
                    processing: {
                        ...state.processing,
                        isActive: false,
                    },
                    shipping: {
                        ...state.shipping,
                        isActive: false,
                    },
                    outForDelivery: {
                        ...state.outForDelivery,
                        isActive: false,
                    },
                };
            case 'processing-reactivated':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        isActive: false,
                    },
                    processing: {
                        ...state.processing,
                        isActive: true,
                    },
                    shipping: {
                        ...state.shipping,
                        isActive: false,
                    },
                    outForDelivery: {
                        ...state.outForDelivery,
                        isActive: false,
                    },
                };
            case 'shipping-reactivated':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        isActive: false,
                    },
                    processing: {
                        ...state.processing,
                        isActive: false,
                    },
                    shipping: {
                        ...state.shipping,
                        isActive: true,
                    },
                    outForDelivery: {
                        ...state.outForDelivery,
                        isActive: false,
                    },
                };
            case 'outForDelivery-reactivated':
                return {
                    ...state,
                    ordering: {
                        ...state.ordering,
                        isActive: false,
                    },
                    processing: {
                        ...state.processing,
                        isActive: false,
                    },
                    shipping: {
                        ...state.shipping,
                        isActive: false,
                    },
                    outForDelivery: {
                        ...state.outForDelivery,
                        isActive: true,
                    },
                };

            default:
                break;
        }
        return state;
    }

    const orderStatus = {
        ordering: {
            isActive: false,
            exception1: false,
            exception2: false,
            isCompleted: false,
        },
        processing: {
            isActive: false,
            exception1: false,
            exception2: false,
            isCompleted: false,
        },
        shipping: {
            isActive: false,
            exception1: false,
            exception2: false,
            isCompleted: false,
        },
        outForDelivery: {
            isActive: false,
            exception1: false,
            exception2: false,
            isCompleted: false,
        },
    };
    const fakeEvent: IOrderHub = {
        caT_Description: '',
        caT_DescriptionId: '',
        currentBillToAccount: '',
        currentShipToAccountNumber: '',
        currentEventType: '',
        currentEventType_cryptic: '',
        currentEventDateTime: new Date(),
        currentSourceLocation: '',
        currentSourceLocation_cryptic: '',
        eventId: '',
        eventType_cryptic: '',
        eventCatagory: '',
        eventLevel: '',
        exceptionLevel: '',
        eventDateTime: new Date(),
        sourceLocation_cryptic: '',
        eventCategoryOrder: '',
        globalCorrelationId: '',
        orderNumber: '',
        relatedOrderNumber: '',
        relatedFacilityId: '',
        sourceDateTimeUTC: new Date(),
        logTimeStampUTC: new Date(),
        orderType: '',
        billToAccountNumber: '',
        shiToAccountNumber: '',
        eventType: '',
        eventMessage: '',
        sourceSystem: '',
        sourceLocation: '',
        facilityId: '',
        souceHost: '',
        sourceUser: '',
    };
    const fakeDeliveredEvent: IOrderHub = {
        caT_Description: 'Order details no longer available',
        caT_DescriptionId: '',
        currentBillToAccount: '',
        currentShipToAccountNumber: '',
        currentEventType: CON.OUT_FOR_DELIVERY,
        currentEventType_cryptic: '',
        currentEventDateTime: new Date(),
        currentSourceLocation: '',
        currentSourceLocation_cryptic: '',
        eventId: '',
        eventType_cryptic: '',
        eventCatagory: CON.OUT_FOR_DELIVERY,
        eventLevel: '',
        exceptionLevel: '',
        eventDateTime: new Date(),
        sourceLocation_cryptic: '',
        eventCategoryOrder: '',
        globalCorrelationId: '',
        orderNumber: '',
        relatedOrderNumber: '',
        relatedFacilityId: '',
        sourceDateTimeUTC: new Date(),
        logTimeStampUTC: new Date(),
        orderType: '',
        billToAccountNumber: '',
        shiToAccountNumber: '',
        eventType: '',
        eventMessage: '',
        sourceSystem: '',
        sourceLocation: '',
        facilityId: '',
        souceHost: '',
        sourceUser: '',
    };
    const [currentEvent, setCurrentEvent] = useState<IOrderHub>(
        order.orderEvent.hubOrderDetails.length !== 0
            ? order.orderEvent.hubOrderDetails[
                  order.orderEvent.hubOrderDetails.length - 1
              ]
            : order.shipDate
            ? fakeDeliveredEvent
            : fakeEvent
    );
    const [state, dispatch] = useReducer(statusReducer, orderStatus);
    const [orderEventCategory] = useState(currentEvent.eventCatagory);
    const [exceptionLevel] = useState(parseInt(currentEvent.exceptionLevel));

    useEffect(() => {
        if (orderEventCategory === CON.ORDERING) {
            dispatch({ type: 'ordering-active' });
            /* ah ah ah ah wait to dispatch these until exceptions are in scope
            if (exceptionLevel && exceptionLevel === 2) {
                dispatch({ type: 'ordering-exception-2' });
            } else if (exceptionLevel && exceptionLevel === 1) {
                dispatch({ type: 'ordering-exception-1' });
            }
            */
        } else if (orderEventCategory === CON.PROCESSING) {
            dispatch({ type: 'processing-active' });
            /*
            if (exceptionLevel && exceptionLevel === 2) {
                dispatch({ type: 'processing-exception-2' });
            } else if (exceptionLevel && exceptionLevel === 1) {
                dispatch({ type: 'processing-exception-1' });
            }
            */
        } else if (orderEventCategory === CON.SHIPPING) {
            dispatch({ type: 'shipping-active' });
            /*
            if (exceptionLevel && exceptionLevel === 2) {
                dispatch({ type: 'shipping-exception-2' });
            } else if (exceptionLevel && exceptionLevel === 1) {
                dispatch({ type: 'shipping-exception-1' });
            }
            */
        } else if (orderEventCategory === CON.OUT_FOR_DELIVERY) {
            if (
                currentEvent.caT_Description ===
                'Order details no longer available'
            ) {
                dispatch({ type: 'outForDelivery-complete' });
            } else {
                dispatch({ type: 'outForDelivery-active' });
            }

            /*
            if (exceptionLevel && exceptionLevel === 2) {
                dispatch({ type: 'outForDelivery-exception-2' });
            } else if (exceptionLevel && exceptionLevel === 1) {
                dispatch({ type: 'outForDelivery-exception-1' });
            }
            */
        }
    }, [order.orderEvent]);

    const changeCategory = (category: string) => {
        //set only the selected category to isActive if the view details button is clicked
        switch (category) {
            case CON.ORDERING:
                dispatch({ type: 'ordering-reactivated' });
                break;
            case CON.PROCESSING:
                dispatch({ type: 'processing-reactivated' });
                break;
            case CON.SHIPPING:
                dispatch({ type: 'shipping-reactivated' });
                break;
            case CON.OUT_FOR_DELIVERY:
                dispatch({ type: 'outForDelivery-reactivated' });
                break;

            default:
                break;
        }
    };
    const viewButtonCheck = (category: string) => {
        //if it's the current category and not active show it
        // if it's completed and not active show it
        // if it like John Cougar Mellencamp set it to Suckin' on Chili Dog
        if (
            cancelled ||
            currentEvent.caT_Description === 'Order details no longer available'
        ) {
            return false;
        }
        if (category === CON.ORDERING) {
            if (
                (!state.ordering.isActive && state.ordering.isCompleted) ||
                (!state.ordering.isActive &&
                    currentEvent.eventCatagory === CON.ORDERING)
            ) {
                return true;
            }
        }
        if (category === CON.PROCESSING) {
            if (
                (!state.processing.isActive && state.processing.isCompleted) ||
                (!state.processing.isActive &&
                    currentEvent.eventCatagory === CON.PROCESSING)
            ) {
                return true;
            }
        }
        if (category === CON.SHIPPING) {
            if (
                (!state.shipping.isActive && state.shipping.isCompleted) ||
                (!state.shipping.isActive &&
                    currentEvent.eventCatagory === CON.SHIPPING)
            ) {
                return true;
            }
        }
        if (category === CON.OUT_FOR_DELIVERY) {
            if (
                (!state.outForDelivery.isActive &&
                    state.outForDelivery.isCompleted) ||
                (!state.outForDelivery.isActive &&
                    currentEvent.eventCatagory === CON.OUT_FOR_DELIVERY)
            ) {
                return true;
            }
        }
        return false;
    };
    const exceptionCheck = (category: string) => {
        //if there is an exception and the category is not completed show it
        if (cancelled) {
            return false;
        }
        if (category === CON.ORDERING) {
            if (!state.ordering.isCompleted) {
                if (state.ordering.exception1 || state.ordering.exception2) {
                    return true;
                }
            }
        }
        if (category === CON.PROCESSING) {
            if (!state.processing.isCompleted) {
                if (
                    state.processing.exception1 ||
                    state.processing.exception2
                ) {
                    return true;
                }
            }
        }
        if (category === CON.SHIPPING) {
            if (!state.shipping.isCompleted) {
                if (state.shipping.exception1 || state.shipping.exception2) {
                    return true;
                }
            }
        }
        if (category === CON.OUT_FOR_DELIVERY) {
            if (!state.outForDelivery.isCompleted) {
                if (
                    state.outForDelivery.exception1 ||
                    state.outForDelivery.exception2
                ) {
                    return true;
                }
            }
        }
        return false;
    };
    const setPTagStyle = (category: string) => {
        if (category === CON.ORDERING) {
            if (state.ordering.isCompleted && state.ordering.isActive) {
                return 'chev-category p-completed-active';
            } else if (
                state.ordering.isActive &&
                !state.ordering.exception1 &&
                !state.ordering.exception2
            ) {
                return 'chev-category p-active';
            } else if (state.ordering.isActive && cancelled) {
                return 'chev-category p-exception-2';
            } else if (state.ordering.exception1) {
                return 'chev-category p-exception-1';
            } else if (state.ordering.exception2) {
                return 'chev-category p-exception-2';
            } else if (state.ordering.isCompleted && !cancelled) {
                return 'chev-category p-completed';
            } else {
                return 'chev-category';
            }
        }
        if (category === CON.PROCESSING) {
            if (state.processing.isCompleted && state.processing.isActive) {
                return 'chev-category p-completed-active';
            } else if (
                state.processing.isActive &&
                !state.processing.exception1 &&
                !state.processing.exception2
            ) {
                return 'chev-category p-active';
            } else if (state.processing.isActive && cancelled) {
                return 'chev-category p-exception-2';
            } else if (state.processing.exception1) {
                return 'chev-category p-exception-1';
            } else if (state.processing.exception2) {
                return 'chev-category p-exception-2';
            } else if (state.processing.isCompleted && !cancelled) {
                return 'chev-category p-completed';
            } else {
                return 'chev-category';
            }
        }
        if (category === CON.SHIPPING) {
            if (state.shipping.isCompleted && state.shipping.isActive) {
                return 'chev-category p-completed-active';
            } else if (
                state.shipping.isActive &&
                !state.shipping.exception1 &&
                !state.shipping.exception2
            ) {
                return 'chev-category p-active';
            } else if (state.shipping.isActive && cancelled) {
                return 'chev-category p-exception-2';
            } else if (state.shipping.exception1) {
                return 'chev-category p-exception-1';
            } else if (state.shipping.exception2) {
                return 'chev-category p-exception-2';
            } else if (state.shipping.isCompleted && !cancelled) {
                return 'chev-category p-completed';
            } else {
                return 'chev-category';
            }
        }
        if (category === CON.OUT_FOR_DELIVERY) {
            if (
                state.outForDelivery.isCompleted &&
                state.outForDelivery.isActive
            ) {
                return 'chev-category p-completed-active';
            } else if (
                state.outForDelivery.isActive &&
                !state.outForDelivery.exception1 &&
                !state.outForDelivery.exception2
            ) {
                return 'chev-category p-active';
            } else if (state.outForDelivery.isActive && cancelled) {
                return 'chev-category p-exception-2';
            } else if (state.outForDelivery.exception1) {
                return 'chev-category p-exception-1';
            } else if (state.outForDelivery.exception2) {
                return 'chev-category p-exception-2';
            } else if (state.outForDelivery.isCompleted && !cancelled) {
                return 'chev-category p-completed-active';
            } else {
                return 'chev-category';
            }
        }
        return 'chev-category';
    };
    const warningDisplay = (category: string) => {
        if (cancelled) {
            return false;
        }
        if (category === CON.ORDERING) {
            if (!state.ordering.isActive && !state.ordering.isCompleted) {
                if (state.ordering.exception1 || state.ordering.exception2) {
                    return true;
                }
            }
        }
        if (category === CON.PROCESSING) {
            if (!state.processing.isActive && !state.processing.isCompleted) {
                if (
                    state.processing.exception1 ||
                    state.processing.exception2
                ) {
                    return true;
                }
            }
        }
        if (category === CON.SHIPPING) {
            if (!state.shipping.isActive && !state.shipping.isCompleted) {
                if (state.shipping.exception1 || state.shipping.exception2) {
                    return true;
                }
            }
        }
        if (category === CON.OUT_FOR_DELIVERY) {
            if (
                !state.outForDelivery.isActive &&
                !state.outForDelivery.isCompleted
            ) {
                if (
                    state.outForDelivery.exception1 ||
                    state.outForDelivery.exception2
                ) {
                    return true;
                }
            }
        }

        return false;
    };
    const chevCatClass = (category: string): string => {
        switch (category) {
            case CON.ORDERING:
                if (state.ordering.isActive && cancelled) {
                    return 'chev chev-exception-2';
                } else if (state.ordering.isActive) {
                    return 'chev chev-active';
                } else if (state.ordering.exception1) {
                    return 'chev chev-exception-1';
                } else if (state.ordering.exception2) {
                    return 'chev chev-exception-2';
                } else if (state.ordering.isCompleted && !cancelled) {
                    return 'chev chev-completed';
                }
                return 'chev';
            case CON.PROCESSING:
                if (state.processing.isActive && cancelled) {
                    return 'chev chev-exception-2';
                } else if (state.processing.isActive) {
                    return 'chev chev-active';
                } else if (state.processing.exception1) {
                    return 'chev chev-exception-1';
                } else if (state.processing.exception2) {
                    return 'chev chev-exception-2';
                } else if (state.processing.isCompleted && !cancelled) {
                    return 'chev chev-completed';
                }
                return 'chev';
            case CON.SHIPPING:
                if (state.shipping.isActive && cancelled) {
                    return 'chev chev-exception-2';
                } else if (state.shipping.isActive) {
                    return 'chev chev-active';
                } else if (state.shipping.exception1) {
                    return 'chev chev-exception-1';
                } else if (state.shipping.exception2) {
                    return 'chev chev-exception-2';
                } else if (state.shipping.isCompleted && !cancelled) {
                    return 'chev chev-completed';
                }
                return 'chev';
            case CON.OUT_FOR_DELIVERY:
                if (state.outForDelivery.isActive && cancelled) {
                    return 'chev chev-exception-2';
                } else if (state.outForDelivery.isActive) {
                    return 'chev chev-active';
                } else if (state.outForDelivery.exception1) {
                    return 'chev chev-exception-1';
                } else if (state.outForDelivery.exception2) {
                    return 'chev chev-exception-2';
                } else if (state.outForDelivery.isCompleted && !cancelled) {
                    return 'chev chev-active';
                }
                return 'chev';
            default:
                break;
        }
        return 'chev';
    };

    return (
        <div id="order-hub" className="order-hub">
            <div
                className="order-event-progress-bar"
                id="order-event-progress-bar"
            >
                <OrderCategory
                    state={state}
                    chevCatClass={chevCatClass}
                    warningDisplay={warningDisplay}
                    setPTagStyle={setPTagStyle}
                    exceptionCheck={exceptionCheck}
                    changeCategory={changeCategory}
                    viewButtonCheck={viewButtonCheck}
                    currentEvent={currentEvent}
                    cancelled={cancelled}
                />
                <ProcessingCategory
                    state={state}
                    chevCatClass={chevCatClass}
                    warningDisplay={warningDisplay}
                    setPTagStyle={setPTagStyle}
                    exceptionCheck={exceptionCheck}
                    changeCategory={changeCategory}
                    viewButtonCheck={viewButtonCheck}
                    currentEvent={currentEvent}
                    cancelled={cancelled}
                />
                <ShippingCategory
                    state={state}
                    chevCatClass={chevCatClass}
                    warningDisplay={warningDisplay}
                    setPTagStyle={setPTagStyle}
                    exceptionCheck={exceptionCheck}
                    changeCategory={changeCategory}
                    viewButtonCheck={viewButtonCheck}
                    currentEvent={currentEvent}
                    cancelled={cancelled}
                />
                <OutForDeliveryCategory
                    state={state}
                    chevCatClass={chevCatClass}
                    warningDisplay={warningDisplay}
                    setPTagStyle={setPTagStyle}
                    exceptionCheck={exceptionCheck}
                    changeCategory={changeCategory}
                    viewButtonCheck={viewButtonCheck}
                    currentEvent={currentEvent}
                    cancelled={cancelled}
                />
            </div>
            <EventMessaging
                orderEvent={order.orderEvent}
                orderStatus={state}
                cancelled={cancelled}
                currentEvent={currentEvent}
            />
        </div>
    );
};

export default OrderTracker;
